/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteTeamDefaultBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteTeamDefaultBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteTeamDefaultBudgetQueryParamOwner
>;

export type DeleteTeamDefaultBudgetRequest = {
  owner: DeleteTeamDefaultBudgetQueryParamOwner;
  orgId?: string | undefined;
};

export const DeleteTeamDefaultBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteTeamDefaultBudgetScope = ClosedEnum<
  typeof DeleteTeamDefaultBudgetScope
>;

export const DeleteTeamDefaultBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteTeamDefaultBudgetOwner = ClosedEnum<
  typeof DeleteTeamDefaultBudgetOwner
>;

/**
 * OK
 */
export type DeleteTeamDefaultBudgetResponseBody = {
  scope: DeleteTeamDefaultBudgetScope;
  scopeId: string;
  owner: DeleteTeamDefaultBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteTeamDefaultBudgetQueryParamOwner$inboundSchema:
  z.ZodNativeEnum<typeof DeleteTeamDefaultBudgetQueryParamOwner> = z.nativeEnum(
    DeleteTeamDefaultBudgetQueryParamOwner,
  );
/** @internal */
export const DeleteTeamDefaultBudgetQueryParamOwner$outboundSchema:
  z.ZodNativeEnum<typeof DeleteTeamDefaultBudgetQueryParamOwner> =
    DeleteTeamDefaultBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteTeamDefaultBudgetRequest$inboundSchema: z.ZodType<
  DeleteTeamDefaultBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  owner: DeleteTeamDefaultBudgetQueryParamOwner$inboundSchema,
  org_id: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
  });
});
/** @internal */
export type DeleteTeamDefaultBudgetRequest$Outbound = {
  owner: string;
  org_id?: string | undefined;
};

/** @internal */
export const DeleteTeamDefaultBudgetRequest$outboundSchema: z.ZodType<
  DeleteTeamDefaultBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteTeamDefaultBudgetRequest
> = z.object({
  owner: DeleteTeamDefaultBudgetQueryParamOwner$outboundSchema,
  orgId: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
  });
});

export function deleteTeamDefaultBudgetRequestToJSON(
  deleteTeamDefaultBudgetRequest: DeleteTeamDefaultBudgetRequest,
): string {
  return JSON.stringify(
    DeleteTeamDefaultBudgetRequest$outboundSchema.parse(
      deleteTeamDefaultBudgetRequest,
    ),
  );
}
export function deleteTeamDefaultBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTeamDefaultBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteTeamDefaultBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTeamDefaultBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteTeamDefaultBudgetScope$inboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamDefaultBudgetScope
> = z.nativeEnum(DeleteTeamDefaultBudgetScope);
/** @internal */
export const DeleteTeamDefaultBudgetScope$outboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamDefaultBudgetScope
> = DeleteTeamDefaultBudgetScope$inboundSchema;

/** @internal */
export const DeleteTeamDefaultBudgetOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamDefaultBudgetOwner
> = z.nativeEnum(DeleteTeamDefaultBudgetOwner);
/** @internal */
export const DeleteTeamDefaultBudgetOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteTeamDefaultBudgetOwner
> = DeleteTeamDefaultBudgetOwner$inboundSchema;

/** @internal */
export const DeleteTeamDefaultBudgetResponseBody$inboundSchema: z.ZodType<
  DeleteTeamDefaultBudgetResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  scope: DeleteTeamDefaultBudgetScope$inboundSchema,
  scope_id: z.string(),
  owner: DeleteTeamDefaultBudgetOwner$inboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    "scope_id": "scopeId",
  });
});
/** @internal */
export type DeleteTeamDefaultBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteTeamDefaultBudgetResponseBody$outboundSchema: z.ZodType<
  DeleteTeamDefaultBudgetResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteTeamDefaultBudgetResponseBody
> = z.object({
  scope: DeleteTeamDefaultBudgetScope$outboundSchema,
  scopeId: z.string(),
  owner: DeleteTeamDefaultBudgetOwner$outboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    scopeId: "scope_id",
  });
});

export function deleteTeamDefaultBudgetResponseBodyToJSON(
  deleteTeamDefaultBudgetResponseBody: DeleteTeamDefaultBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteTeamDefaultBudgetResponseBody$outboundSchema.parse(
      deleteTeamDefaultBudgetResponseBody,
    ),
  );
}
export function deleteTeamDefaultBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteTeamDefaultBudgetResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeleteTeamDefaultBudgetResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteTeamDefaultBudgetResponseBody' from JSON`,
  );
}
